import React, {useEffect} from 'react';
import styles from './SessionInfo.module.css';
import {format} from 'date-fns';
import locale from 'date-fns/locale/ru';
import {formatDistanceStrict} from 'date-fns';
import {getSessionTime} from '../../utils/sessionTime';

const renderBlocks = (blocks) => {
  return Object.entries(blocks).map(([key, {label, value}]) => (
    <div key={key} className={styles.infoBlock}>
      <div className={styles.infoBlockLabel}>{label}</div>
      <div className={styles.infoBlockValue}>{value || '-'}</div>
    </div>
  ));
};

const UserIcon = () => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 11C4.08 11 2 14 2 16V19H18V16C18 14 15.92 11 10 11Z" fill="#667FFF"/>
      <path d="M10 10C12.4853 10 14.5 7.98528 14.5 5.5C14.5 3.01472 12.4853 1 10 1C7.51472 1 5.5 3.01472 5.5 5.5C5.5 7.98528 7.51472 10 10 10Z" fill="#667FFF"/>
    </svg>
  );
};

export default function SessionInfo({
  sessionInfo
}) {
  const sessionTime = getSessionTime();
  const [now, setNow] = React.useState(+Date.now());
  useEffect(() => {
    const intervalId = setInterval(() => {
      setNow(+Date.now());
    }, 1000);
    return () => {
      clearInterval(intervalId);
    };
  }, []);
  const blocks = {
    left: {
      user: {
        label: 'Пользователь',
        value: [sessionInfo.firstname, sessionInfo.middleName, sessionInfo.surname].filter((name) => name).join(' '),
      },
      role: {
        label: 'Роль',
        value: sessionInfo.roleName ?? 'Не определена',
      },
    },
    right: {
      sessionDuration: {
        label: 'Время работы',
        value: formatDistanceStrict(sessionTime, now, {locale}),
      },
      currentDateTime: {
        label: 'Текущая дата и время',
        value: format(now, 'dd.MM.yyyy HH:mm')
      }
    }
  };
  return (
    <div className={styles.sessionInfo}>
      <div className={styles.avatarContainer}>
        <div className={styles.defaultAvatar}>
          <UserIcon/>
        </div>
      </div>
      <div className={styles.infoContainer}>
        <div className={styles.infoBlocks}>
          {renderBlocks(blocks.left)}
        </div>
        <div className={styles.infoBlocks}>
          {renderBlocks(blocks.right)}
        </div>
      </div>
    </div>
  );
}
